import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { app } from "@/main";
import { computed, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberField',
  props: {
    modelValue: {},
    required: { type: Boolean },
    textAlign: { default: "right" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const $format = app.config.globalProperties.$format;

const props = __props;

const emit = __emit;

const internalValue = ref<string>("");

const model = computed({
  get: () => props.modelValue,
  set: (value: number | null) => {
    if (props.required && value === null) {
      value = 0;
    }
    internalValue.value = $format.decimal(value);
    emit("update:modelValue", value);
  },
});

watch(
  model,
  () => {
    internalValue.value =
      model.value !== null ? $format.decimal(model.value) : "";
  },
  { immediate: true }
);

if (props.required && props.modelValue === null) {
  model.value = 0;
}
const focus = (event: Event) => {
  const target = event.target as HTMLInputElement;
  target.select();
};

const parse = (val: string) => {
  val = val.replaceAll(",", "").replaceAll(" ", "");
  const num = parseFloat(val);
  if (isNaN(num)) return null;
  return num;
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, _mergeProps(_ctx.$attrs, {
    class: `${_ctx.textAlign}-input`,
    "model-value": internalValue.value,
    onFocus: focus,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (internalValue.value = $event)),
    "onUpdate:focused": _cache[1] || (_cache[1] = ($event: any) => ($event ? null : (model.value = parse(internalValue.value))))
  }), null, 16, ["class", "model-value"]))
}
}

})